module.exports = __webpack_public_path__ + "img/Idon.c963380a.png";